import OfficeAdminRoute from "../../Routes/OfficeAdminRoute";
import SuperAdminRoute from "../../Routes/SuperAdminRoute";

export const getRoutesByRole = (role) => {

  switch (role) {
    case "SUPER_USER":
      return SuperAdminRoute;
    case "OFFICE_ADMIN":
      return OfficeAdminRoute;
    default:
      return []; // Or redirect to NotFound
  }
};
